export default __webpack_public_path__ + "static/media/photo7.5f7c9c40.jpg";